/**
 * Form layout for CardConnect Payment (OMD0043) popup.
 * Used with FormField control: Payment method radio, Trans #, Customer, Amount, Profile, Account.
 * @param {string} [paymentProfile] - If set, "Pay using Profile" is enabled and "Create Profile and Pay" disabled; otherwise "Pay using Card" default and "Pay using Profile" disabled.
 */
export function getCardConnectPayLayout(paymentProfile) {
    const hasProfile = !!paymentProfile;
    return [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CARDCONNECT_PAYMENT_METHOD",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Payment method",
                "type": "radio",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
                "options": [
                    { "value": "profile", "text": "Pay using Profile", "disabled": !hasProfile },
                    { "value": "card", "text": "Pay using Card" },
                    { "value": "newProfile", "text": "Create Profile and Pay", "disabled": hasProfile },
                ],
            },
        ],
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CARDCONNECT_TRANS_NO",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trans #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
        ],
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CARDCONNECT_CUSTOMER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
        ],
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "CARDCONNECT_AMOUNT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Amount",
                "type": "number",
                "required": false,
                "visible": true,
                "readOnly": true,
                "format": "#,##0.00",
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
        ],
    },
    {
        "groupId": 5,
        "fields": []
    },
    {
        "groupId": 5,
        "label": "",
        "fields": [
            {
                "name": "CARDCONNECT_PROFILE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": !hasProfile,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
        ],
    },
    {
        "groupId": 6,
        "label": "",
        "fields": [
            {
                "name": "CARDCONNECT_ACCOUNT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Account",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
        ],
    },
];
}

export const CardConnectPayLayout = getCardConnectPayLayout("");
